import "core-js/modules/es6.array.sort.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import keys from 'lodash/keys';
import transform from 'lodash/transform';
import invert from 'lodash/invert';
import flatten from 'lodash/flatten';
import isEmpty from 'lodash/isEmpty';
var PRODUCTS_PER_PAGE = 40;
var SORT_BY = {
  popular: 'popular',
  publishdate: 'publishdate',
  price: 'price'
};
var ORDER_BY = {
  default: 'default',
  asc: 'asc',
  desc: 'desc'
};
var ENCODED_CATEGORY_FILTERS = {
  'sold_by.seller_name': 'se',
  'filters.filter_eco_responsability.facet_label': 'ecr',
  'filters.filter_scent.facet_label': 'sc',
  'filters.filter_bed_size.facet_label': 'bes',
  'filters.filter_bed_head_size.facet_label': 'beh',
  'filters.filter_nb_seat.facet_label': 'nbs',
  'filters.filter_brand.facet_label': 'ba',
  'segmentations.category_name': 'ct',
  'filters.filter_capacity.facet_label': 'ca',
  'filters.filter_plus_product.facet_label': 'pp',
  'filters.filter_form.facet_label': 'fo',
  'filters.filter_ideal_for.facet_label': 'if',
  'filters.filter_christmas_theme.facet_label': 'cht',
  'segmentations.colors.label': 'c',
  'segmentations.styles.label': 'st',
  'segmentations.fabrics.label': 'f',
  price: 'p',
  'segmentations.dimensions.depth': 'dd',
  'segmentations.dimensions.height': 'dh',
  'segmentations.dimensions.width': 'dw',
  more_info: 'mi',
  width: 'dw',
  height: 'dh',
  depth: 'dd'
};
var DECODED_CATEGORY_FILTERS = invert(ENCODED_CATEGORY_FILTERS);

var extractFacetLabelFromCategoryFilters = (filters, filter, facet) => {
  var isNumericFacets = filter === 'price' || filter === 'width' || filter === 'height' || filter === 'depth';
  var isBooleanFacets = filter === 'more_info' || filter === 'is_new' || filter === 'is_on_sales' || filter === 'is_made_in_france';
  if (isNumericFacets || isBooleanFacets) return facet;
  var extracted = filters.find(e => e.name === filter).facets.find(e => e.key === facet);
  return extracted ? extracted.label : null;
};

var extractSelectedFilters = (filterBy, filters) => {
  if (!filters || !filterBy) return [];
  var result = [];
  Object.keys(filterBy).forEach(filter => {
    var hasDeepFilter = ['depth', 'width', 'height'].includes(filter);

    if (hasDeepFilter) {
      result.push({
        filter,
        facet: filterBy[filter][0],
        label: "".concat(filterBy[filter][0], " cm")
      });
    } else {
      result.push(filterBy[filter].map(facet => ({
        filter,
        facet,
        label: extractFacetLabelFromCategoryFilters(filters, filter, facet)
      })));
    }
  });
  return flatten(result);
};

var supportedFilterBy = (query, decoder) => {
  var supported = keys(decoder);
  return transform(query, (currentQuery, value, key) => {
    var isSupported = supported.includes(key) && value !== '';
    return Object.assign(currentQuery, isSupported && {
      [key]: value
    });
  }, {});
};

var extractFilterByFromQuery = decoder => query => transform(supportedFilterBy(query, decoder), (result, value, key) => {
  var currentResult = result;
  var hasSpace = /,(?=(\s|%20))/;

  if (hasSpace.test(value)) {
    currentResult[decoder[key]] = [value];
  } else {
    currentResult[decoder[key]] = !isEmpty(value) ? value.split(',') : [];
  }
}, {});

var extractQueryFromFilterBy = encoder => query => transform(query, (result, value, key) => {
  var currentResult = result;
  currentResult[encoder[key]] = value.length ? value.join(',') : null;
}, {});

var extractCategoryQueryFromFilterBy = extractQueryFromFilterBy(ENCODED_CATEGORY_FILTERS);
var extractCategoryFilterByFromQuery = extractFilterByFromQuery(DECODED_CATEGORY_FILTERS);

var extractCategorySortByFromQuery = query => SORT_BY[query.sort] || SORT_BY.popular;

var extractCategoryOrderByFromQuery = query => ORDER_BY[query.order] || null;

var extractPageFromQuery = query => parseInt(query.page, 10) || 1;

var extractCategoryPreviousPageFromQuery = extractPageFromQuery;
var extractCategoryNextPageFromQuery = extractPageFromQuery;

var buildCategoryProductsQuery = query => {
  var filterBy = extractCategoryFilterByFromQuery(query);
  var sortBy = extractCategorySortByFromQuery(query) || SORT_BY.popular;
  var orderBy = extractCategoryOrderByFromQuery(query) || ORDER_BY.default;
  var page = extractPageFromQuery(query) || 1;
  var algoliaFilters = JSON.stringify(query);
  return {
    offset: (extractPageFromQuery(query) - 1) * PRODUCTS_PER_PAGE,
    limit: PRODUCTS_PER_PAGE,
    sortBy: sortBy.toUpperCase(),
    orderBy: orderBy.toUpperCase(),
    filterBy: keys(filterBy).map(e => ({
      filter: e,
      facets: filterBy[e]
    })),
    algoliaFilters,
    page
  };
};

export { extractCategoryFilterByFromQuery, extractCategoryQueryFromFilterBy, extractCategorySortByFromQuery, extractCategoryOrderByFromQuery, extractCategoryPreviousPageFromQuery, extractCategoryNextPageFromQuery, buildCategoryProductsQuery, extractSelectedFilters };